export var Modals;

(function (Modals) {
  Modals["Error"] = "Error";
  Modals["AddNewUser"] = "AddNewUser";
  Modals["AddNewRegistrar"] = "AddNewRegistrar";
  Modals["AddNewOrganization"] = "AddNewOrganization";
})(Modals || (Modals = {}));